import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PoolWizard } from "@/components/app/boloes/PoolWizard";

export default function BolaoNovo() {
  return (
    <div className="space-y-6">
      <div>
        <Button variant="ghost" size="sm" asChild className="mb-2 -ml-2">
          <Link to="/app/boloes"><ArrowLeft className="mr-1 h-4 w-4" /> Bolões</Link>
        </Button>
        <h1 className="font-serif text-3xl">Novo bolão</h1>
        <p className="text-sm text-muted-foreground">Escolha as dezenas, a estratégia de fechamento e gere as combinações</p>
      </div>
      <PoolWizard />
    </div>
  );
}
